<script>
import {pipe, map, min, pickAll, merge} from 'ramda'
import { fontSizer, scaleStyle, $getFontSize } from '../../theme-helpers'
import tap from 'tap-logger'
import debounce from 'lodash.debounce'
/**
 *
 * Nota: Por cuestiones de eficiencia, la función para hacer resize del texto, corre en single-application y se llama resizeFont
 */

export default {
	props: [
		'id', // Int
		'sticker', // {id, height, start_height, width, start_width, text_color, url}
		'stickerText', // ['string', 'string']
		'selectedForm', // {width, height}
		'font' // String
	],
	ready() {
		var reference = document.getElementById('text-container-reference-'+this.id)
		this.line1 = document.getElementById('line1-'+this.id)
		this.line2 = document.getElementById('line2-'+this.id)
		this.setParentStyles()
		$(window).on('resize', this.setParentStyles)
		this.resizeFont()
	},
	data() {
		return {
			parentStyles: {
				height: 0,
				width: 0
			},
			line1: {},
			line2: {},
			font_size: 0
		}
	},

	methods: {
		setParentStyles() {
			let $container = $('.sticker-container')
			let stickerColWidth = $container.width() //columnas de 50%
			let scale = stickerColWidth/this.selectedForm.width
			let stickerColHeight = this.selectedForm.height * scale
		 	this.parentStyles = {
				height: stickerColHeight,//será la altura máxima de cada sticker
			 	width: stickerColWidth,//será el ancho máximo de cada sticker
		 	}
		},
		resizeFont() {
			let stampData = pipe(
				pickAll(['height', 'width'])
			)(this.textContainerStyles)

			let ref = $(`#${this.id} .text-container-reference`)
			let line1 = $(`#${this.id} .text-container--line1`)
			let line2 = $(`#${this.id} .text-container--line2`)

			fontSizer(parseInt(stampData.width, 10), parseInt(stampData.height, 10), ref, line1, line2, 'nowhere')
 			this.font_size = min($getFontSize(line1), $getFontSize(line2))
		}
	},

	computed: {
		stickerId() {
			return this.sticker.id
		},
		stickerStyles() {
			return merge(
				{
					height: this.selectedForm.height + 'px',
					width: this.selectedForm.width + 'px',
					backgroundImage: `url(${this.sticker.url})`
				},
				scaleStyle(
					this.parentStyles,
					{height: this.selectedForm.height, width: this.selectedForm.width}
				)
			)
		},
		textContainerStyles() {
			return merge(
				{
					height: this.sticker.height + 'px',
					width: this.sticker.width + 'px',
					top:  this.sticker.start_height + 'px',
					left:  this.sticker.start_width + 'px',
					color: this.sticker.text_color
				},
				this.font ? {fontFamily: this.font} : {}
			)
		}
	},

	events: {
		'resize-font': function() {
			this.resizeFont()
		}
	},

	watch: {
		font_size() {
			this.$dispatch('new-font-size', {
				id: this.sticker.id,
				font_size: this.font_size
			})
		}
	}

}
</script>

<template lang="pug">
div.sticker-container(:id="id" :style="'height: ' + parentStyles.height + 'px'")
	div.sticker(:style="stickerStyles")
		div.text-container-main(:style="textContainerStyles")
			.text-container-reference
				p.text-container.text-container--line1(:id="'line1-'+id" v-text="stickerText[0]")
				p.text-container.text-container--line2(:id="'line2-'+id" v-text="stickerText[1]")

</template>

<style lang="scss" scoped>
	.sticker {
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		&-container {
			position: relative;
			margin-bottom: 15px;
		}
	}
	.text-container-main {
			// margin-left: 20px;
			position: absolute;
			top: 0;
			background-color: transparent;
		}

		.text-container-reference {
			position: absolute;/*importante para poder resolver el width*/
			top: 0;
			left: 0;
			margin-bottom: 0;
		}

		p {
			text-align: center;
			margin-top: 0;
			margin-bottom: 5px;
			font-size: 16px;
		}

</style>
